import { FunctionComponent } from "react";
import { Route, Switch } from "react-router";
import { CollectionPage, HelpPage, ProjectLayoutPage, LegacyCollectionRedirect, SignInPage, ForgotPasswordPage, ResetPasswordPage } from "pages";
import { UserWrapper } from "components/user";
import { Notifications } from "components/notifications";
import { ProjectCacheProvider } from "hooks/useProject";
import { FavoritesProvider } from "hooks/useFavorites";
// import { ThemeWrapper } from "components/theme";
import "styles/reset.css";
import "styles/globals.css";
import "styles/theme.css";
import "styles/app.css";

/**
 * The main app component which renders all other components.
 * Used to store routing information for each page.
 */
const App: FunctionComponent = () => {
  return (
    <Notifications>
      <UserWrapper>
        <FavoritesProvider>
        <ProjectCacheProvider>
        {/* <ThemeWrapper> */}
        <Switch>
          {/* Home page route. */}
          <Route exact path="/" component={CollectionPage} />

          {/* Help page route. */}
          <Route exact path="/help" component={HelpPage} />

          {/* Old bookmarked /collection?projectId=... links; redirects to /:projectId/form. */}
          <Route exact path="/collection" component={LegacyCollectionRedirect} />

          {/* Authentication page routes. */}
          <Route exact path="/signin" component={SignInPage} />
          <Route exact path="/signin/forgotpassword" component={ForgotPasswordPage} />
          <Route exact path="/signin/resetpassword" component={ResetPasswordPage} />

          {/* Project routes (overview, form editor, errors) share one layout so the
              project header stays mounted across them. Wildcard, not exact — keep
              this last so it doesn't shadow the literal routes above. */}
          <Route path="/:projectId" component={ProjectLayoutPage} />
        </Switch>
        {/* </ThemeWrapper> */}
        </ProjectCacheProvider>
        </FavoritesProvider>
      </UserWrapper>
    </Notifications>
  );
};

export default App;
